import React from 'react'
import { t } from "i18next";
import { Fragment } from 'react'
import { Link } from "react-router-dom";
import NumberFormat from 'react-number-format';

function Product({idx, lang, prod,chainId, selectProd, companyUser, getProductTranslations}) {
    return (
        <Fragment>
            {!!idx == 0 ?
                <h2 className="name" tabIndex="0" aria-label={getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName }}></h2>
                :
                <h2 className="name" aria-label={getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName }}></h2>
            }
            <div className="descr" role="application" aria-roledescription={t("description")} aria-label={getProductTranslations(prod).productShortDescription} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productShortDescription }}></div>
            <div className="prod-box-bottom d-flex justify-content-between">
                <div className="price" role="application" aria-roledescription={t("price")} aria-label={(companyUser ? prod.productPriceAfterDiscount : prod.productPrice) + prod.currencyCode.replace("ILS", "₪")}><NumberFormat value={companyUser ? prod.productPriceAfterDiscount : prod.productPrice} displayType={'text'} thousandSeparator={true} prefix={prod.currencyCode.replace("ILS", "₪")} /></div>
                <Link
                    onClick={e => selectProd(prod, `/product?chainid=${chainId}&pid=${prod.productId}&lang=${lang}`)}
                    className="btn"
                    aria-label={`${t("moreInfAndRsv")} ${getProductTranslations(prod).productName}`}
                    to={`/product?chainid=${chainId}&pid=${prod.productId}&lang=${lang}`}
                >
                    {t("moreInfAndRsv")}
                </Link>
            </div>
        </Fragment>
    )
}

export default Product